import { JwtPayload } from 'jwt-decode';

export function calculateExpiresAtFromNow(expiresInSeconds: number) {
  const issuedAt = new Date();
  const expiresAt = new Date(issuedAt.getTime() + expiresInSeconds * 1000).toISOString();

  return expiresAt;
}

export function calculateRefreshDelay(expiresAtStr: string): number | null {
  const now = new Date();
  const expiresAt = new Date(expiresAtStr);
  const refreshInMs = expiresAt.getTime() - now.getTime() - 10 * 60 * 1000;

  return refreshInMs > 0 ? refreshInMs : null;
}

export function isExpired(expiresAt: string): boolean {
  return new Date() >= new Date(expiresAt);
}

export function isTokenExpired(payload: JwtPayload): boolean {
  if (!payload.exp) {
    return true;
  }

  const expirationDate = new Date(payload.exp * 1000);

  return new Date() >= expirationDate;
}
